import { format } from "date-fns";
import { HbrCancel, HbrInfoIcon } from "../newComponents/Mycustomsvgicons";
import { useState } from "react";

const TodaySchedule = ({startTime,endTime,videoTitle,videoThumbnail}) => {
    const [expandText,setExpandText]=useState(false);
    const [isImageClicked,setIsImageClicked]=useState(false);



    return ( 
        <div className="todayschedule flex-row2" style={{width:"100%",background:"#101010",position:"relative",caretColor:"transparent"}}>

                <div style={{borderRight:"1px solid white",width:"20%",height:"100%",borderLeft:"1px solid white"}}>
                    <pre style={{color:"white",fontSize:"0.8em",fontWeight:"bold",paddingLeft:"10px"}}>
                        {`${format(new Date(startTime),"hh:mm a")} - \n \n ${format(new Date(endTime),"hh:mm a")}`}
                    </pre>
                </div>

                <div className="flex-column1" style={{borderRight:"1px solid white",width:"60%",height:"100%",overflow:"hidden",whiteSpace:"nowrap",position:"relative"}}>
                    <p style={{color:"white"}}>{videoTitle}</p>
                    <HbrInfoIcon width={"1.7em"} height={"1.7em"} fillColour={"white"} handleClick={()=>setExpandText(prev => !prev)}/>
                </div>

                <div style={{borderRight:"1px solid white",width:"20%",cursor:"pointer"}} onClick={()=>setIsImageClicked(true)}>
                    <img src={videoThumbnail} alt="" style={{width:"90%", height:"90%",padding:"10px", objectFit:"contain"}} />
                </div>

                {expandText && 
                        <div className="flex-column2" style={{backgroundColor:"#252a41",borderRadius:"10px",position:"absolute",top:"50%",width:"300px",zIndex:"1",boxShadow:"0px 10px 20px rgba(0, 0, 0, 0.19), 0px 6px 6px rgba(0, 0, 0, 0.23)",padding:"10px"}}>
                            <div style={{display:"flex",width:"100%",alignItems:"flex-end",justifyContent:"flex-end"}}>
                                <HbrCancel width={"1.7em"} height={"1.7em"} fillColour={"white"} handleClick={()=>setExpandText(false)} />
                            </div>
                            <p style={{color:"white",fontWeight:"bold"}}>{videoTitle}</p>
                            <img src={videoThumbnail} alt="" style={{width:"100px", height:"100px", objectFit:"contain",cursor:"pointer"}} onClick={()=>setIsImageClicked(true)}/>
                        </div>
                }

                {isImageClicked && 
                        <div className="flex-column2" style={{backgroundColor:"#101010",width:"70%",height:"70vh",borderRadius:"10px",position:"fixed",top:"10%",left:"20%",zIndex:"1",boxShadow:"0px 10px 20px rgba(0, 0, 0, 0.19), 0px 6px 6px rgba(0, 0, 0, 0.23)",padding:"10px"}}>
                            <div style={{display:"flex",width:"100%",alignItems:"flex-end",justifyContent:"flex-end"}}>
                                <HbrCancel width={"1.7em"} height={"1.7em"} fillColour={"white"} handleClick={()=>setIsImageClicked(false)} />
                            </div>
                            <img src={videoThumbnail} alt="" style={{width:"auto", height:"90%"}} onClick={()=>setIsImageClicked(true)} />
                        </div>
                }

            
        </div>
     );
}
export default TodaySchedule;